import type {
  Automation,
  AutomationNotificationRecipientMode,
  CreatorPrincipalType,
} from '@/types/automations.ts';

type RecipientOption = {
  value: AutomationNotificationRecipientMode;
  label: string;
};

export function canUseCreatorNotificationMode(createdByType: CreatorPrincipalType): boolean {
  return createdByType === 'user';
}

export function getRecipientOptions(automation: Automation): RecipientOption[] {
  const allowCreatorNotifications = canUseCreatorNotificationMode(automation.created_by_type);
  const creatorLabel =
    automation.created_by_type === 'user' && automation.created_by_email
      ? `Automation creator (${automation.created_by_email})`
      : `Automation creator (${automation.created_by_label})`;

  const options: RecipientOption[] = [];
  if (allowCreatorNotifications) {
    options.push({ value: 'creator', label: creatorLabel });
  }
  options.push({ value: 'custom', label: 'Custom emails' });
  options.push({ value: 'none', label: 'Do not send' });

  return options;
}
